import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "adminTrainerList" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "inner d-flex" }
const _hoisted_5 = { class: "contentArea" }
const _hoisted_6 = { class: "profileRow d-flex justify-between" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = ["onClick"]

import Sidebar from '../admin/adminSidebar.vue'
import Header from '../admin/adminHeader.vue'
import axios from "@/api/profile";
import { ref, onMounted} from 'vue'
import EditProfileModal from '@/components/admin/UpdateProfileModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'profileList',
  setup(__props) {

const memberList = ref([]);
const selectedProfile = ref(null)
const showModal = ref(false)

const fetchMemberList = async () => {
  try {
    const res = await axios.ListProfile()
    memberList.value = res.data.list
    console.log(memberList.value)
  } catch (err) {
    console.error(err)
  }
}

const editProfile = (profileNo: number) => {
  const profile = memberList.value.find(p => p.no === profileNo)
  if (profile) {
    selectedProfile.value = { ...profile }
    showModal.value = true
  }
}
const closeModal = () => {
  showModal.value = false
  selectedProfile.value = null
}

onMounted(() => {
   fetchMemberList()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Sidebar),
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mainTitle d-flex items-center" }, [
                _createElementVNode("h1", null, "멤버 프로필 관리")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberList.value, (profile) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: profile.no,
                    class: "profileCard text-center"
                  }, [
                    _createElementVNode("img", {
                      src: profile.path,
                      alt: profile.name,
                      class: "member-img"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(profile.title), 1),
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(profile.subContent), 1),
                    _createElementVNode("button", {
                      class: "updateBtn mt-1",
                      onClick: ($event: any) => (editProfile(profile.no))
                    }, " 수정 ", 8, _hoisted_10)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(EditProfileModal, {
          key: 0,
          profile: selectedProfile.value,
          onClose: closeModal,
          onUpdated: fetchMemberList
        }, null, 8, ["profile"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})